import Manualdisbursementview from "../../../jsx/components/Dashboard/LoanDetails/manualdisbursementview";

const ManualDisbursementViewWrapper = () => {
  return <Manualdisbursementview />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];
export default constore(ManualDisbursementViewWrapper);
